import React from "react";
import "./Modal.css";

function Modal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null; // Si el modal no está abierto, no se renderiza

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>{title}</h3>
                <div className="modal-body">{children}</div>
                <button className="close-button" onClick={onClose}>
                    Cerrar
                </button>
            </div>
        </div>
    );
}

export default Modal;
